module.exports = __webpack_public_path__ + "static/media/Rajaraman.b3fb7797.jpeg";